/*!
 * angular-translate - v2.13.1 - 2016-12-06
 *
 * Copyright (c) 2016 The angular-translate team, Pascal Precht; Licensed MIT
 */
!(function (a, b) {
  'function' == typeof define && define.amd
    ? define([], function () {
        return b();
      })
    : 'object' == typeof exports
    ? (module.exports = b())
    : b();
})(this, function () {
  function a(a, b) {
    'use strict';
    return function (c) {
      if (!c || !c.url) throw new Error("Couldn't use urlLoader since no url is given!");
      var d = {};
      return (
        (d[c.queryParameter || 'lang'] = c.key),
        b(angular.extend({ url: c.url, params: d, method: 'GET' }, c.$http)).then(
          function (a) {
            return a.data;
          },
          function () {
            return a.reject(c.key);
          },
        )
      );
    };
  }
  return (
    (a.$inject = ['$q', '$http']),
    angular.module('pascalprecht.translate').factory('$translateUrlLoader', a),
    (a.displayName = '$translateUrlLoader'),
    'pascalprecht.translate'
  );
});
